module.exports = __webpack_public_path__ + "painelutaajuus.png?75836a6c24e2027298a10048d70138d4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/painelutaajuus.png
// module id = 324
// module chunks = 0